import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import CategoryGroups from 'Components/CategoryGroups/CategoryGroups';
import { Heading2 } from 'uikit/Heading';

import {
  availableServicesByL2Query,
  availableServicesByL3Query,
  AvailableServicesResponse,
  extractCategoriesTree,
} from './RegisterAvailableServices.helpers';
import './RegisterAvailableServices.scss';

type Props = {
  l2Slug?: string;
  l3Slug?: string;
};

const RegisterAvailableServices: FC<Props> = (props) => {
  const slug = props.l2Slug || props.l3Slug;
  const query = props.l2Slug ? availableServicesByL2Query : availableServicesByL3Query;

  const { data } = useQuery<AvailableServicesResponse>(query, {
    variables: { slug },
    skip: !slug,
  });

  if (!data) return null;

  return (
    <section id="available-services" className="registerAvailableServices">
      <div className="container">
        <Heading2 className="registerAvailableServices__title">
          <Trans>Dostępne usługi</Trans>
        </Heading2>
        <CategoryGroups categories={extractCategoriesTree(data)} />
      </div>
    </section>
  );
};

export default RegisterAvailableServices;
